import React, { useEffect } from "react";

/**
 * Renders a thin, non-intrusive Google AdSense ad (120x600) for sidebar use.
 * Only visible on large screens (handled by parent layout).
 */
const AdComponent = ({ slot }) => {
  useEffect(() => {
    // Try to (re)load ads if AdSense is available
    if (window.adsbygoogle && process.env.NODE_ENV === "production") {
      try {
        window.adsbygoogle.push({});
      } catch (e) {
        // Ignore errors
      }
    }
  }, []);

  return (
    <div style={{
      width: 120,
      minHeight: 600,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 auto",
      background: "transparent"
    }}>
      <ins
        className="adsbygoogle"
        style={{ display: "block", width: 120, height: 600 }}
        data-ad-client="ca-pub-5155733545546703"
        data-ad-slot="1234567890"
        data-ad-format="vertical"
        data-full-width-responsive="false"
      ></ins>
    </div>
  );
};

export default AdComponent;
